import styles from './Third.module.scss';
import {Component} from "react";
import {CopyToClipboard} from 'react-copy-to-clipboard';
import premier from '../../../resources/icons/premier.svg';
import copy from '../../../resources/icons/copy.svg';

export class Third extends Component {
    state = {
        value: 'koldui',
        copied: false,
    };

    render() {
        return (
            <div className={styles.wrapper}>
                <div className={styles.content}>
                    <div className={styles.logo}>
                        <img src={premier} alt="Premier"/>
                    </div>
                    <div className={styles.title}>Онлайн-кинотеатр Premier<br/>кидает инвайт</div>
                    <div className={styles.desc}>
                        До 10 января Premier открыл портал <a href="https://premier.one" target="_blank" rel="nofollow noreferrer">в онлайн-кинотеатр</a>. Одному идти опасно, возьми промокод на 45 дней подписки
                    </div>
                    <CopyToClipboard text={this.state.value} onCopy={() => this.setState({copied: true})}>
                        <div id="promocode" className={styles.button}>
                            <span>koldui</span>
                            <img src={copy} alt="Копировать"/>
                            {this.state.copied ? <div className={styles.copy}>Скопировано</div> : null}
                        </div>
                    </CopyToClipboard>
                </div>
            </div>
        )
    }
}